import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../Translator';
import Icon from '../Icon';
import styles from './Divider.module.css';

const bindClasses = classNameBind.bind(styles);

const Divider = ({
  type,
  t,
  dataId,
  boldText,
  vertical,
  icon,
  noMargin,
}) => (
  <div className={bindClasses('divider', { vertical, noMargin })} data-ppuc-id={dataId}>
    <div className={bindClasses('line', { withText: type !== 'default' || !!icon })} />
    {icon
      && (
        <div className={bindClasses('icon-wrapper')}>
          <Icon
            name={icon}
            color="gray"
            size="tiny"
          />
        </div>
      )
    }
    {type !== 'default' && !icon
     && (
       <div className={bindClasses('text', { boldText })} data-ppuc-id={`${dataId}.type`}>
         {
          // eslint-disable-next-line no-nested-ternary
          ['and', 'or', 'vs'].includes(type)
            ? t(type)
            : (type !== 'default' ? type : null)
          }
       </div>
     )}
    <div className={bindClasses('line', { withText: type !== 'default' || !!icon })} />
  </div>
);

Divider.defaultProps = {
  type: 'default',
  dataId: 'Divider',
  boldText: false,
  vertical: false,
};

const enhanced = withTranslation('components')(Divider);
enhanced.displayName = 'Divider';

export default enhanced;
export { Divider };
